import { Component, inject } from '@angular/core';
import { BootStateService } from '../../services/boot-state.service';

@Component({
  selector: 'app-loading-splash',
  standalone: true,
  template: `
    @if (!boot.ready()) {
      <div class="splash" role="alert" aria-busy="true" aria-live="polite">
        <img class="splash__logo" src="assets/WatchGuard_Logo_Black_Red.png" alt="" />
        <div class="splash__spinner"></div>
        <div class="splash__label">Signing you in…</div>
        <span class="sr-only">Signing you in. Please wait.</span>
      </div>
    }
  `,
  styles: [`
    .splash {
      position: fixed; inset: 0;
      display: flex; flex-direction: column; align-items: center; justify-content: center;
      gap: 18px;
      background: var(--surface, #ffffff);
      z-index: 9999;
    }
    .splash__logo { width: 220px; max-width: 60vw; height: auto; }
    .splash__label { font-weight: 500; font-size: 14px; color: var(--text-2, #5a6072); }
    .splash__spinner {
      width: 28px; height: 28px; border-radius: 50%;
      border: 3px solid rgba(216, 30, 44, 0.18);
      border-top-color: var(--accent, #d81e2c);
      animation: splash-spin 0.8s linear infinite;
    }
    @keyframes splash-spin { to { transform: rotate(360deg); } }
    .sr-only {
      position: absolute; width: 1px; height: 1px;
      padding: 0; margin: -1px; overflow: hidden;
      clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
    }
  `],
})
export class LoadingSplashComponent {
  readonly boot = inject(BootStateService);
}
